<div class="d-flex flex-column">
  <div>
    @if (showButtons) {
      <button
        class="btn btn-dark d-inline-block ms-1  me-1"
        (click)="getExcelFile()"
        >
        {{ "EXCEL" | translate }}
      </button>
    }
    @if (applicationService.getSelectCompanyGroupCode() !== 'WG' && applicationService.getSelectCompanyGroupCode() !== 'GHO') {
      <button
        class="btn btn-dark d-inline-block "
        (click)="getPdfFile()"
        >
        {{ "PDF" | translate }}
      </button>
    }
  </div>
  <small class="d-block">
    {{ "NO_FILTERS_APPLIED" | translate }}
  </small>
</div>
